import { z } from 'zod';
export const schemaArticleStock = z.object({
  reference: z.string().trim().min(2).max(60),
  libelle: z.string().trim().min(3).max(200),
  unite: z.string().trim().min(1).max(30).default('u'),
  seuil: z.number().int().min(0).max(1000000).default(0),
  emplacement: z.string().trim().max(250).default(''),
});
export const schemaMouvementStock = z
  .object({
    type: z.enum(['IN', 'OUT', 'ADJUST']),
    quantite: z.number().int().min(0).max(1000000),
    motif: z.string().trim().min(3).max(500),
    version: z.number().int().positive(),
    intervention_id: z.string().uuid().nullable().default(null),
  })
  .refine((d) => d.type === 'ADJUST' || d.quantite > 0, {
    message: 'Une entrée ou sortie doit être strictement positive',
    path: ['quantite'],
  });
